export default __webpack_public_path__ + "static/Entenda0026-fa74641c704f2281e55d7847eb44d4a6.jpg";